<template>
  <div class="main-container">
    <div v-for="(message, index) in chatMessages" :key="index">
      <div class="receptor" v-if="message.from === 'bot'">
        <div class="receptor-logo">
          <img src="@/assets/img/Ingenierito.png" alt="logo-receptor" />
          <span class="receptor-time">{{ message.time }}</span>
        </div>
        <div class="receptor-mensaje">
          <p>{{ message.text }}</p>
          
          <button class="copy-button" @click="copyBotMessage(message.text)">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19.53 8L14 2.47C13.8595 2.32931 13.6688 2.25018 13.47 2.25H11C10.2707 2.25 9.57118 2.53973 9.05546 3.05546C8.53973 3.57118 8.25 4.27065 8.25 5V6.25H7C6.27065 6.25 5.57118 6.53973 5.05546 7.05546C4.53973 7.57118 4.25 8.27065 4.25 9V19C4.25 19.7293 4.53973 20.4288 5.05546 20.9445C5.57118 21.4603 6.27065 21.75 7 21.75H14C14.7293 21.75 15.4288 21.4603 15.9445 20.9445C16.4603 20.4288 16.75 19.7293 16.75 19V17.75H17C17.7293 17.75 18.4288 17.4603 18.9445 16.9445C19.4603 16.4288 19.75 15.7293 19.75 15V8.5C19.7421 8.3116 19.6636 8.13309 19.53 8ZM14.25 4.81L17.19 7.75H14.25V4.81ZM15.25 19C15.25 19.3315 15.1183 19.6495 14.8839 19.8839C14.6495 20.1183 14.3315 20.25 14 20.25H7C6.66848 20.25 6.35054 20.1183 6.11612 19.8839C5.8817 19.6495 5.75 19.3315 5.75 19V9C5.75 8.66848 5.8817 8.35054 6.11612 8.11612C6.35054 7.8817 6.66848 7.75 7 7.75H8.25V15C8.25 15.7293 8.53973 16.4288 9.05546 16.9445C9.57118 17.4603 10.2707 17.75 11 17.75H15.25V19ZM17 16.25H11C10.6685 16.25 10.3505 16.1183 10.1161 15.8839C9.8817 15.6495 9.75 15.3315 9.75 15V5C9.75 4.66848 9.8817 4.35054 10.1161 4.11612C10.3505 3.8817 10.6685 3.75 11 3.75H12.75V8.5C12.7526 8.69811 12.8324 8.88737 12.9725 9.02747C13.1126 9.16756 13.3019 9.24741 13.5 9.25H18.25V15C18.25 15.3315 18.1183 15.6495 17.8839 15.8839C17.6495 16.1183 17.3315 16.25 17 16.25Z" fill="#C3C3C3"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="emisor" v-else>
        <span class="emisor-time">{{ message.time }}</span>
        <div class="emisor-mensaje">
          <p>{{ message.text }}</p>
        </div>
      </div>
    </div>
    <button class="boton-responder" v-if="loading" type="button">
      <span class="boton-text">Dejar de responder</span>
      <div class="boton-icon">
        <div class="boton-icon_1"></div>
        <div class="boton-icon_2"></div>
      </div>
    </button>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "DefaultChat",
  data() {
    return {
      message: "Default",
      chatMessages: [],
    };
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  methods:{
    copyBotMessage(text) {
      // Crea un elemento de texto oculto
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);

      // Selecciona y copia el texto
      textArea.select();
      document.execCommand('copy');

      // Elimina el elemento de texto oculto
      document.body.removeChild(textArea);
    },
  },
  watch: {
    messages(newMessages) {
      this.chatMessages = newMessages;
    },
  },
});
</script>

<style scoped>
/* 1. CONTENEDOR PRINCIPAL: Ocupa todo el espacio y usa Flexbox */
.main-container {
  display: flex;
  flex-direction: column; /* Mensajes uno debajo del otro */
  
  /* CAMBIO CLAVE: Quitamos ancho fijo y posición absoluta */
  position: relative; 
  width: 100%; 
  height: 100%; /* O la altura fija que necesites, ej: 460px */
  min-height: 460px; /* Aseguramos altura mínima */
  
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 15px 80px 15px; /* Aire a los costados */
}

/* 2. CADA MENSAJE (Wrapper): Se ajusta solo */
.receptor, .emisor {
  position: relative;
  width: auto;
  max-width: 85%; /* Evita que los mensajes sean líneas eternas en PC */
  margin-bottom: 15px; /* Espacio entre mensajes */
}

/* 3. BOT (Receptor): Pegado a la Izquierda */
.receptor {
  align-self: flex-start; /* MAGIA: Esto lo pega a la izquierda */
  margin-right: auto;     /* Empuja todo lo demás a la derecha */
  
  /* Quitamos el 'left: 20px' que causaba problemas */
  margin-left: 0; 
}

/* 4. USUARIO (Emisor): Pegado a la Derecha */
.emisor {
  align-self: flex-end; /* MAGIA: Esto lo pega a la derecha */
  margin-left: auto;    /* Empuja todo lo demás a la izquierda */
  
  /* Quitamos el 'left: 68px' */
  right: 0;
}

/* ESTILOS INTERNOS (Globos y textos) */
.receptor-logo {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.receptor-logo img {
  width: 44px;
  height: 44px;
  margin-right: 8px;
}

.receptor-time, .emisor-time {
  font-family: Montserrat;
  font-size: 10px;
  color: #666;
}

.emisor-time {
  display: block;
  text-align: right; /* La hora del usuario a la derecha */
  margin-bottom: 2px;
}

/* GLOBO DEL MENSAJE (BOT) */
.receptor-mensaje {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  background: #FFF59D; /* Color amarillo */
  position: relative;
  padding: 10px 40px 10px 15px;
  border-radius: 0px 15px 15px 15px; /* Esquina superior izq cuadrada */
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  word-wrap: break-word; /* Romper palabras largas */
}

/* GLOBO DEL MENSAJE (USUARIO) */
.emisor-mensaje {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE; /* Color gris */
  padding: 10px 15px;
  border-radius: 15px 0px 15px 15px; /* Esquina superior der cuadrada */
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  word-wrap: break-word;
}

.receptor-mensaje p, .emisor-mensaje p {
  margin: 0;
  padding: 0;
}

/* BOTÓN DE RESPONDER / CARGANDO */
.boton-responder {
  align-self: center; /* Centrado abajo */
  width: 216px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid #f8bc02;
  background: #ffffff;
  margin-top: 10px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.boton-text {
  color: rgba(248, 188, 2, 1);
  font-family: Anek Latin;
  font-size: 12px;
  font-weight: 700;
}

.boton-icon {
  width: 19px;
  height: 19px;
  position: relative;
}

.boton-icon_1 {
  width: 100%;
  height: 100%;
  background: rgba(248, 188, 2, 1);
  border-radius: 50%;
}

.boton-icon_2 {
  width: 8px;
  height: 8px;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* BOTÓN DE COPIAR (Ajustado) */
.copy-button {
  background: transparent;
  border: none;
  cursor: pointer;
  float: none; /* Flotar a la derecha del texto */
  margin-left: 10px;
  margin-top: 2px;
  position: absolute;
  bottom: 5px;
  right: 5px;
  margin: 0;
}

.copy-button svg {
  width: 16px;
  height: 16px;
  fill: #C3C3C3;
}
</style>